module.exports = __webpack_public_path__ + "img/attention.3d4eccbd.svg";